import { h } from 'preact';
import styles from './DidYouMean.module.scss';
export function DidYouMean({ suggestions, onSuggestionClick }) {
    if (!suggestions || suggestions.length === 0) {
        return null;
    }
    return (h("div", { class: styles.didYouMean },
        h("span", { class: styles.label }, "Did you mean:"),
        suggestions.map((suggestion, index) => (h("button", { key: suggestion, class: styles.suggestion, onClick: () => onSuggestionClick(suggestion) }, suggestion)))));
}
